<form class="flex flex-col flex-grow" [formGroup]="formGroup()" (ngSubmit)="onSubmitPress()">
  <ng-content/>
  <div [ngClass]="{'mt-auto': !noButtonPadding()}" class="flex justify-between gap-2">
    <ng-content select="[additionalButtons]"/>
    <p-button styleClass="flex-1" [ngClass]="{'font-bold': newButtonStyle()}" type="submit"
              [loading]="state() === 'loading'"
              [disabled]="this.formGroup().invalid"
              [severity]="newButtonStyle() ? 'contrast' : 'primary'"
              [size]="buttonSize()"
    >
      {{submitButtonLabel()}}
    </p-button>
  </div>
</form>
